// @vendors
const Immutable = require('immutable');
const moment = require('moment');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../raConstants/index');

// @utilities
const { getDay, todayDate } = require('utilities/dateHelper');

const initialState = Immutable.fromJS({
    saveSimulationObjective: {
        amount: 0,
        clientRiskProfile: null,
        currency: 'EUR',
        endDate: null,
        hasRecurringTransfer: false,
        initialContribution: null,
        simulationId: null,
        maxTypeOfProduct: null,
        name: '',
        recurringTransfer: null,
        selectedPortfolio: null,
        type: null,
        isFetching: false,
        success: false,
        error: false,
    },
    saveSimulationPortfolio: {
        error: null,
        errorFlags: false,
        recurringAmountError: false,
        errorChangingProduct: null,
        initialContributionAmount: 0,
        investProfileCode: '',
        investProfileDescription: '-',
        investProfileValue: '',
        investSliderValue: 1,
        isFetchingInvestProfile: false,
        isChangingProduct: false,
        isChangingProductSuccess: false,
        isFetchedInvestProfile: false,
        isSavingSimulation: false,
        maxInvestProfileValue: 1,
        modifyPlanValue: '',
        name: '',
        newProfile: null,
        periodicity: CONTRIBUTION_PERIOD_MONTHLY,
        portfolioCustomName: '',
        recurringContributionAmount: '',
        recurringContributionDay: getDay(todayDate()),
        saveSuccess: false,
        selectedGoal: '',
        showDetails: true,
        includeGoal: false,
        isSaveSimulationModalOpen: false,
        isSaveSimulationButtonDisabled: true,
    },
});

const getValidEndOfDate = endDate => {
    if (!endDate || moment(endDate) < moment().add(1, 'years')) {
        return null;
    }
    return endDate;
};

const RASaveSimulation = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_FOR_PORTFOLIO:
            return state.mergeIn(['saveSimulationPortfolio'], {
                isFetchingInvestProfile: true,
                error: null,
            });
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_FOR_OBJECTIVE:
            return state.mergeIn(['saveSimulationObjective'], {
                isFetching: true,
                success: false,
                error: false,
            });
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_OBJECTIVE: {
            const {
                amount,
                clientRiskProfile,
                currency,
                endDate,
                hasRecurringTransfer,
                initialContribution,
                id,
                maxTypeOfProduct,
                name,
                recurringTransfer,
                selectedPortfolio,
                type,
                error,
            } = action.payload;
            return state.mergeIn(['saveSimulationObjective'], {
                amount: amount,
                clientRiskProfile: clientRiskProfile,
                currency: currency,
                endDate: getValidEndOfDate(endDate),
                hasRecurringTransfer: hasRecurringTransfer,
                initialContribution: initialContribution,
                simulationId: id,
                maxTypeOfProduct: maxTypeOfProduct,
                name: name,
                recurringTransfer: recurringTransfer,
                selectedPortfolio: selectedPortfolio,
                type: type,
                isFetching: false,
                success: true,
                error: error,
            });
        }
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_PORTFOLIO:
            const {
                initialContribution,
                maxTypeOfProduct,
                selectedPortfolio,
                hasRecurringTransfer,
                id,
                displayName,
                name,
                error,
            } = action.payload;

            let recurringTransfer = {};
            let newState = state;

            if (hasRecurringTransfer) {
                const {
                    amount,
                    cutDay,
                    frequencyCode,
                } = action.payload.recurringTransfer;

                newState = newState.mergeIn(['saveSimulationPortfolio'], {
                    periodicity: frequencyCode,
                    recurringContributionAmount: amount,
                    recurringContributionDay: cutDay,
                });
            }

            return newState.mergeIn(['saveSimulationPortfolio'], {
                initialContributionAmount: initialContribution || 0,
                investProfileValue: selectedPortfolio || '',
                investSliderValue: maxTypeOfProduct || 1,
                maxInvestProfileValue: maxTypeOfProduct || 1,
                isFetchingInvestProfile: false,
                isFetchedInvestProfile: true,
                name,
                newProfile: selectedPortfolio,
                portfolioCustomName: displayName,
                simulationId: id,
                errorFlags:
                    initialContribution <
                        MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT &&
                    initialContribution > 0,
                recurringAmountError:
                    hasRecurringTransfer &&
                    recurringTransfer.amount < 1 &&
                    recurringTransfer.amount > 0,
                error: error,
            });
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_FAILURE:
            return state.mergeIn(['saveSimulationPortfolio'], {
                isFetching: false,
                error: true,
                saveSimulationObjective: initialState.get(
                    'saveSimulationPortfolio',
                ),
            });
        case actionTypes.RA_SAVE_SIMULATION_REQUEST_TO_SAVE_DATA_FOR_PORTFOLIO:
            return state.mergeIn(['saveSimulationPortfolio'], {
                error: null,
                isSavingSimulation: true,
            });
        case actionTypes.RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_PORTFOLIO:
            return state.mergeIn(['saveSimulationPortfolio'], {
                saveSuccess: true,
                isSavingSimulation: false,
            });
        case actionTypes.RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_PORTFOLIO:
            return state.mergeIn(['saveSimulationPortfolio'], {
                error: action.payload.error,
            });
        case actionTypes.RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_OBJECTIVE:
            return state.mergeIn(['saveSimulationObjective'], {
                error: false,
            });
        case actionTypes.RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_OBECTIVE:
            return state.mergeIn(['saveSimulationObjective'], {
                error: true,
            });
        case actionTypes.RA_SAVE_SIMULATION_RESET:
            return state.merge({
                saveSimulationPortfolio: {},
            });
        case actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_VALUE_RESET:
            return state.merge({
                saveSimulationObjective: {},
            });
        default:
            return state;
    }
};

module.exports = RASaveSimulation;
